export default {
    title: '先行技術',
    add: '先行技術を追加',
    searchPlaceholder: '特許を検索...',
    noResults: '先行技術が見つかりません',
    searchHint: '特許を追加して関連する先行技術を追跡',
    viewDetails: '特許詳細を見る',
    moreResults: 'さらに先行技術',
    delete: '削除',
    cancel: 'キャンセル',
    deleteSuccess: '削除に成功しました',
    deleteFailed: '削除に失敗しました',
    dialog: {
        title: '先行技術を追加',
        subtitle: '特許番号で検索するか、発明を説明してください。',
        placeholder: '例：US20230123456 または発明を説明：\'スプリングアームを使用した自己センタリングアライメント機構を備えた光ファイバーコネクタ...\'',
        proTip: 'プロのヒント：完全な段落を貼り付けると、より良い意味マッチングが得られます。',
        search: '検索',
        searching: '検索中...',
        found: '見つかりました',
        results: '件の結果',
        enterQuery: 'クエリを入力して検索を開始',
        noResults: '一致する特許が見つかりません',
        resultsWillAppear: '検索結果がここに表示されます',
        searchFailed: '検索に失敗しました。後でもう一度お試しください',
        selected: '選択済み',
        cancel: 'キャンセル',
        addSelected: '選択したものを追加',
        noSelected: '少なくとも1つの特許を選択してください',
        addSuccess: '{count}件の特許を正常に追加しました',
        addFailed: '特許の追加に失敗しました。もう一度お試しください',
    },
};
